<template>
  <div class="m-create-user-for-employee">
    <b-modal
      v-if="record.fullName"
      :id="id"
      v-model="localActive"
      size="custom-size"
      centered
      hide-footer
      hide-header
      @close="localActive = false"
    >
      <svg
        class="m-create-user-for-employee-close"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="localActive = false"
      >
        <path
          d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
          fill="#8E9CBB"
        />
        <path
          d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
          fill="#8E9CBB"
        />
      </svg>

      <div v-if="modalTitle" class="m-create-user-for-employee-title">
        {{ modalTitle }}
      </div>

      <div class="m-create-user-for-employee-fullname">{{ record.fullName.value }}</div>

      <c-input
        v-model="login"
        class="m-create-user-for-employee-input"
        floating-label="Логин"
        :max-length="20"
        :required="isSubmitted && loginError"
        :required-message="isSubmitted && loginError"
        :required-mark="true"
        :clearable="true"
      />

      <div class="row">
        <div class="col col-12 col-md-12 col-xl-6">
          <c-input
            type="password"
            v-model="password"
            class="m-create-user-for-employee-input"
            floating-label="Пароль"
            :max-length="16"
            :required="isSubmitted && passwordError"
            :required-message="isSubmitted && passwordError"
          />
        </div>
        <div class="col col-12 col-md-12 col-xl-6">
          <c-input
            type="password"
            v-model="passwordConfirmation"
            class="m-create-user-for-employee-input"
            floating-label="Подтверждение пароля"
            :max-length="16"
            :required="isSubmitted && passwordConfirmationError"
            :required-message="isSubmitted && passwordConfirmationError"
          />
        </div>
        <div class="col col-12 col-md-12 col-xl-12"><p class="message">Если поле «пароль» не заполнено, пароль будет сгенерирован автоматически</p></div>
      </div>

      <div class="row">
        <div class="col col-12 col-md-12 col-xl-6">
          <c-input
            v-model="email"
            class="m-create-user-for-employee-input"
            floating-label="Email сотрудника"
            :required="isSubmitted && emailError"
            :required-message="isSubmitted && emailError"
            :required-mark="true"
            :clearable="true"
            :max-length="128"
          />
        </div>
        <div class="col col-12 col-md-12 col-xl-6">
          <c-input
            v-model="role"
            class="m-create-user-for-employee-input"
            type="select"
            floating-label="Роль"
            :multiple="true"
            :searchable="true"
            :items="collections.roles"
            :required="isSubmitted && roleError"
            :required-message="isSubmitted && roleError"
            :required-condition="isSubmitted && roleError"
            :required-mark="true"
          />
        </div>
      </div>

      <!-- <c-input-old
        v-model="inputLocal"
        class="m-create-user-for-employee-input"
        :class="{ 'm-create-user-for-employee-input-error': isInputNotValidate }"
        floating-label="Email"
      /> -->

      <!-- <div v-if="isInputNotValidate" class="m-create-user-for-employee-input-error-content">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle data-v-218d3eb7="" cx="7" cy="7" r="6.5" fill="white" stroke="#FF238D"></circle>
          <circle data-v-218d3eb7="" cx="7" cy="10" r="1" fill="#FF238D"></circle>
          <rect data-v-218d3eb7="" x="6" y="3" width="2" height="5" rx="1" fill="#FF238D"></rect>
        </svg>
        <div class="m-create-user-for-employee-input-error-content-text">{{ inputNotValidateDescription }}</div>
      </div> -->

      <div class="m-create-user-for-employee-buttons">
        <c-button color="white" label="Отменить" @click="closeModal" />
        <c-button color="primary" label="Сохранить" :disabled="isPending" @click="createUser" />
      </div>
    </b-modal>

    <b-modal
      v-if="record.fullName"
      id="create-user-employee-modal-success"
      v-model="localActiveSuccessModal"
      size="custom-size"
      centered
      hide-footer
      hide-header
    >
      <div class="create-user-success-modal">
        <svg
          class="create-user-success-modal-close"
          width="15"
          height="16"
          viewBox="0 0 15 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          @click="localActiveSuccessModal = false"
        >
          <path
            d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
            fill="#8E9CBB"
          />
          <path
            d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
            fill="#8E9CBB"
          />
        </svg>
        <h2 class="create-user-success-modal-title">Пользователь успешно добавлен</h2>
        <div class="create-user-success-modal-description">
          Для сотрудника <span class="create-user-success-modal-description-bold">{{ record.fullName.value }}</span> создан пользователь.
        </div>
        <div class="create-user-success-modal-item">
          <div class="create-user-success-modal-item-name">Логин</div>
          <div class="create-user-success-modal-item-value">{{ user.username }}</div>  
        </div>
        <div class="create-user-success-modal-item">
          <div class="create-user-success-modal-item-name">Пароль</div>
          <div class="create-user-success-modal-item-value"><copy-field :text="user.password" :editable="true" :password="true" success="Пароль скопирован в буфер обмена"></copy-field></div>  
        </div>
        <button type='button' class='c-button close-popover c-button-ok create-user-success-modal-close-btn' @click="localActiveSuccessModal = false">
          <span class='c-button-label'>Закрыть</span>
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Button from "@/components/controls2/Button";
import InputOld from "@/components/controls/input-old";
import Input from "@/components/controls2/Input";
import CopyField from "@/components/copy-field";
import Select from "@/components/controls2/Select";

export default {
  name: "m-change-status",
  components: {
    "c-button": Button,
    "c-input-old": InputOld,
    "c-input": Input,
    "c-select": Select,
    CopyField,
  },
  props: ["active", "modalTitle", "buttons", "input", "id", "record"],

  data() {
    return {
      baseUrl: window.location.origin,
      localActive: false,
      localActiveSuccessModal: false,
      inputLocal: "",
      isInputNotValidate: false,
      isSendingNotValidateValue: false,
      inputNotValidateDescription: "",
      userForEmployeeName: "",
      userForEmployeeId: null,

      isSubmitted: false,
      login: "",
      password: "",
      passwordConfirmation: "",
      email: "",
      role: [],

      isPending: false,

      collections: {
        roles: [],
      },

      user: {},
    };
  },

  computed: {
    ...mapGetters("employees", ["createUserForEmployee"]),
    loginError() {
      let error = '';

      if (!this.login.length) {
        error = 'Обязательное поле'
      } else if (this.login.length < 2) {
        error = 'Должно быть введено хотя бы 2 символа'
      } else if (!/^([a-z0-9-_.]+){0,2}$/i.test(this.login)) {
        error = 'Некорректное значение. Используйте латинские буквы, знак подчёркивания, тире, цифры, точку'
      }

      return error
    },
    passwordError() {
      let error = '';

      if (this.password && this.password.length < 6) {
        error = 'Должно быть введено хотя бы 6 символов'
      } else if (/\s/i.test(this.password)) {
        error = 'Некорректное значение. Пароль не может содержать пробелы'
      }

      return error
    },
    passwordConfirmationError() {
      return this.passwordConfirmation !== this.password ? 'Значение должно совпадать со значением параметра «Пароль»' : ''
    },
    emailError() {
      const re = /^(([^<>()[\]\\.,;:\s@"]{1,64}(\.[^<>()[\]\\.,;:\s@"]{1,64})*)|(".{1,64}"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!this.email) {
        return 'Обязательное поле'
      } else if (!re.test(String(this.email).toLowerCase())) {
        return 'Некорректное значение'
      } else {
        return ''
      }
    },
    roleError() {
      return !this.role || (this.role && !this.role.length) ? "Обязательное поле" : ""
    },
    formIsValid() {
      return !this.loginError && !this.passwordError && !this.passwordConfirmationError && !this.emailError && !this.roleError
    }
  },

  watch: {
    localActive(value) {
      if (!value) {
        setTimeout(() => {
          this.inputLocal = "";
        }, 300);
        this.$emit("close");
      } else {
        this.$store.dispatch("tablesSettings/getRoles").then(res => {
          this.collections.roles = res
            .map(role => ({
              value: role.name,
              label: role.description
            }))
            .sort((a, b) => {

              if (a.label.toLowerCase() < b.label.toLowerCase()) {
                return -1;
              }
              if (a.label.toLowerCase() > b.label.toLowerCase()) {
                return 1;
              }
              return 0;
            })

          this.role = [this.collections.roles.find(role => role.value === "Worker")]
        })
        this.$store.dispatch("employees/generateLogin", this.record.id).then(res => {
          this.login = res.result;
        })
      }
    },
    active(value) {
      this.localActive = value;
    },
    inputLocal(value) {
      if (this.isSendingNotValidateValue) {
        if (value.length > 0 && this.validateEmail(value)) {
          this.isInputNotValidate = false;
          this.inputNotValidateDescription = "";
        }
        if (value.length > 0 && !this.validateEmail(value)) {
          this.isInputNotValidate = true;
          this.inputNotValidateDescription = "Неверный формат";
        }
        if (value.length === 0) {
          this.isInputNotValidate = true;
          this.inputNotValidateDescription = "Обязательный параметр";
        }
      }
    },
  },
  methods: {
    closeModal() {
      this.isInputNotValidate = false;
      this.inputNotValidateDescription = "";
      this.localActive = false;
      this.inputLocal = "";
      this.isSendingNotValidateValue = false;
      
      this.isSubmitted = false;
      this.login = ""
      this.password = ""
      this.passwordConfirmation = ""
      this.email = ""
      this.role = []
    },

    getValue(value) {
      this.valueFromInput = value;
    },

    validateEmail(email) {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },

    createUser() {
      this.isSubmitted = true;

      if (this.formIsValid) {
        let params = {
          login: this.login,
          password: this.password,
          email: this.email,
          roles: this.role.map(role => (role.value)).join(','),
          worker_id: this.record.id
        }

        this.isPending = true;
        this.$store.dispatch("employees/createUserForEmployee", params)
          .then((res) => {
            if (res.status && res.status === 'success') {
              this.closeModal();
              this.userForEmployeeName = res.username;
              this.userForEmployeeId = res.user_id;
              this.localActiveSuccessModal = true;
              
              this.user = res;
            } else {
              if (res.message === 'Указанный логин уже добавлен') {
                this.$notify({
                  group: "error-message",
                  data: {
                    textMessage: `Указанный логин уже добавлен`,
                  },
                });
              } else if (res.message.match(/Значение (.*?) для «E-mail» уже занято/)) {
                this.$notify({
                  group: "error-message",
                  data: {
                    textMessage: res.message,
                  },
                });
              } else {
                this.$notify({
                  group: "error-message",
                  data: {
                    textMessage: `Произошла ошибка. Попробуйте ещё раз.`,
                  },
                });
              }

              console.log(res.message)
            }
          })
          .catch(err => {
            console.log(err)
          })
          .finally(res => {
            this.isPending = false;
          })
      }

      // if (this.inputLocal.length === 0) {
      //   this.isInputNotValidate = true;
      //   this.isSendingNotValidateValue = true;
      //   this.inputNotValidateDescription = "Обязательный параметр";
      // } else if (!this.validateEmail(this.inputLocal)) {
      //   this.isInputNotValidate = true;
      //   this.isSendingNotValidateValue = true;
      //   this.inputNotValidateDescription = "Неверный формат";
      // } else {
      //   this.isInputNotValidate = false;
      //   this.inputNotValidateDescription = "";
      // }
    },

    goToEditUser() {
      window.open(`/?r=service-user%2Fchange-password&id=${this.userForEmployeeId}`, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.m-create-user-for-employee {
  position: relative;
  width: 100%;
  transition: 0.2s;

  &-title {
    font: 500 18px Fira Sans;
    line-height: 120%;
  }
  @media (max-width: 700px) {
    &-title {
      font-size: 15px;
    }
  }

  &-fullname {
    font: 400 18px Fira Sans;
    line-height: 120%;
    @media screen and (max-width: 700px) {
      font-size: 15px;
    }
  }

  &-input {
    margin: 30px 0 0 0;

    &-error {
      &-content {
        margin-top: 10px;
        display: flex;
        align-items: center;

        &-text {
          white-space: nowrap;
          font-size: 11px;
          color: #ff238d;
          margin-left: 10px;
        }
      }

      & ::v-deep .c-input .c-input-border {
        background: #ff238d;
      }
    }

    /deep/ {
      .c-input-required-text {
        white-space: unset !important;
      }
    }
  }

  &-close {
    position: absolute;
    top: 12px;
    right: 10px;
    cursor: pointer;
  }

  &-buttons {
    display: flex;
    margin-top: 29px;
    justify-content: flex-end;

    &::v-deep > .c-button:first-child {
      margin-right: 10px;
    }
    @media (max-width: 700px) {
      &::v-deep > .c-button {
        margin-right: 0 !important;
        border-radius: 0;
        width: 50%;
      }

      &::v-deep > .c-button > .c-button__wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        margin: 0 !important;
        border-radius: 0;
      }
    }
  }
  @media (max-width: 700px) {
    &-buttons {
      margin: 30px -20px 0 -20px;
    }
  }
}

.create-user-success-modal {
  &-close {
    cursor: pointer;
    position: absolute;
    top: 12px;
    right: 12px;

    &-btn {
      cursor: pointer;
      background: none;
      border: 1px solid #d3d8df;
      height: 38px;
      border-radius: 19px;
      padding: 0 30px;
      color: #000;
      white-space: nowrap;
      -webkit-transition: 0.2s;
      transition: 0.2s;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-wrap: nowrap;
      flex-wrap: nowrap;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      font-size: 15px;
      font-weight: 500;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      -ms-flex-negative: 0;
      flex-shrink: 0;
      position: relative;
      margin: 10px 0 0 auto;

      @include vp-767 {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 40px;
        border-radius: unset;
      }
    }
  }

  &-title {
    font-size: 18px;
    font-weight: 500;
    line-height: normal;
    margin: 0 0 25px;
  }

  &-description {
    font-size: 15px;
    line-height: 18px;
    margin-bottom: 15px;

    &-bold {
      font-weight: 500;
    }
  }

  &-item {
    display: flex;
    align-items: center;

    &-name {
      color: #8E9CBB;
      font-size: 15px;
      line-height: 150%;
      min-width: 60px;
      margin-right: 5px;
    }

    &-value {
      font-size: 15px;
      font-weight: 500;
      line-height: 150%;
    }

    @include vp-767 {
      flex-direction: column;
      align-items: flex-start;

      &:not(:last-child) {
        margin-bottom: 15px;
      }
    }
  }

  &-additional-info {
    font-family: Fira Sans;
    font-size: 15px;
    line-height: 18px;

    &-link {
      cursor: pointer;
      text-decoration: none;
    }
  }

  @media screen and (max-width: 700px) {
    padding-bottom: 55px;
  }
}

::v-deep .modal-custom-size {
  max-width: 590px !important;
}

::v-deep .modal-body {
  padding: 27px 34px 30px 32px;
}

@media (max-width: 700px) {
  ::v-deep .modal-dialog-centered {
    align-items: flex-start;
  }

  ::v-deep .modal-custom-size {
    max-width: 100% !important;
  }

  ::v-deep .modal-body {
    padding: 28px 20px 0 20px;
  }
}

::v-deep .modal-dialog {
  margin: 0 auto;
}

::v-deep .modal.fade .modal-dialog {
  transform: none;
}

.message {
  color: #8E9CBB;
  font-feature-settings: 'clig' off, 'liga' off;
  font-size: 13px;
  font-weight: 400;
  line-height: 120%;
  margin: 30px 0 0;
}


</style>
